import { Box, Divider, Stack, Typography, CardMedia, IconButton, Grid } from "@mui/material";
import { useWindowSize } from "../../../utils/useWindowSize";

// Component
import { briefInfoType } from "../../../interface/MainInterface";
import KeywordReportImage from "./KeywordReportImage";
import KeywordReportTitle from "./KeywordReportTitle";

// CSS
import "./KeywordReport.css";
import KeywordReportSummary from "./KeywordReportSummary";
import KeywordReportInsight from "./KeywordReportInsight";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface propsType {
  info: any;
}

const KeywordReport = (props: propsType) => {
  const windowSize = useWindowSize();
  const scrapTitle = props.info.scrap_title.split(":");

  return (
    <Box sx={{ mt: "40px" }}>
      <Stack direction={"row"}>
        {/* <Typography sx={{ whiteSpace : 'nowrap' }}>{props.info.scrap_keyword}</Typography> */}
        {/* 혹시 Border 다시 생길까봐 남겨둠 */}
        {/* <Box 
          sx={{ 
            ml: 2, 
            width: "100%", 
            borderBottom: '1px solid #2a2a2a', 
            position: 'relative', 
            top: '50%', 
            transform: 'translateY(-50%)'
          }} 
        /> */}
      </Stack>
      <Box sx={{ mt: 3 }}>
        {scrapTitle.length > 1 
        ? 
        <div className="report-title">
          <Box sx={{
            backgroundColor: "#D0FF00",
            zIndex: -1,
            padding: "0 8px",
            display: "inline-block"
          }}>
            <Typography sx={{ fontWeight: "700", fontSize: "1.5rem" }}>{scrapTitle[0]} : </Typography>
          </Box>
          <div style={{ marginTop: windowSize.width > 1023 ? "0rem" : "0.3rem" }} />
          <Typography sx={{ fontWeight: "700", fontSize: "1.5rem" }}>{scrapTitle[1]}</Typography>
        </div>
        :
          <Typography sx={{ fontWeight: "700", fontSize: "1.5rem" }}>{scrapTitle[0]}</Typography>
        }
      </Box>
      <Box sx={{ marginTop: 3 }}>
        <div className="report-markdown">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {/* <Typography sx={{ fontWeight: "400", fontSize: "1rem"}}> */}
              {props.info.scrap_Introduction}
            {/* </Typography> */}
          </ReactMarkdown>
        </div>
      </Box>
      <Box sx={{ mt: 6, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Stack direction={"column"} spacing={2} sx={{ width: "100%", mb: 2 }}>
          {props.info.scrap_list.map((brief: briefInfoType, index: number) => (
            <KeywordReportSummary key={`detail-brief-${index}`} brief={brief} index={index} />
          ))}
        </Stack>
        <div className="m-fake-height-40" />
        <Box sx={{ display: "flex", justifyContent: "center", width: windowSize.width > 1023 ? "93%": "100%"}}>
          <div className="report-img">
            {props.info.scrap_list.map((brief: briefInfoType, index: number) => (
              <Box
                key={`image-list-${brief.sk}-${index}`}
                sx={{
                  flexGrow: 1,                // 이미지가 균등하게 배치됨
                  maxWidth: windowSize.width > 1023 ? `calc(100% / ${props.info.scrap_list.length})` : '100%',  // 이미지 개수에 맞춰 width 설정
                  height: "180px",            // 고정 height
                }}
              >
                <KeywordReportImage key={`image-list-${index}`} brief={brief} index={index} />
              </Box>
            ))}
          </div>
        </Box>
      </Box>
      <Typography sx={{ fontWeight: "800", fontSize: "1.25rem", mt: 9 }}>인사이트 도출</Typography>
      <Typography sx={{ mt: 3, mb: 1, fontWeight: "400", fontSize: "1rem" }}>{props.info.scrap_Insight}</Typography>
      <Stack direction={"column"}>
        {props.info.scrap_Strategies.map((strategy: string, index: number) => (
          <KeywordReportInsight key={`insight-strategy-${index}`} strategy={strategy} index={index} />
        ))}
      </Stack>
      <Box sx={{ mt : 10 }}></Box>
    </Box>
  );
};

export default KeywordReport;
